import { getUrlParameter, HandleCookies } from '@/utils';

export const getBenchmarkId = () => getUrlParameter('benchmarks_id') || HandleCookies.getCookies({ name: 'benchmarks-id' });
